import './frontend.scss';

// Utilizes "modal-menu" module

// Log in menu mobile customizations
const initLogInMobileMenu = (logInMobileMenu) => {
	// Add class for adding menu offset if WP admin menu is present
	const list = logInMobileMenu.querySelector('.js-log-in-menu-list');

	if (!list) {
		return;
	}

	if (document.body.classList.contains('admin-bar')) {
		list.classList.add('log-in-list-admin-bar-offset');
	}
};

const init = () => {
	const logInMobileMenus = document.querySelectorAll(
		'.js-log-in-menu-mobile'
	);

	if (logInMobileMenus.length) {
		for (const logInMobileMenu of logInMobileMenus) {
			initLogInMobileMenu(logInMobileMenu);
		}
	}
};

document.addEventListener('DOMContentLoaded', init);
